@if (company$ | async; as company) {
  @if (!loading) {
    <div class="smartphoto-detail">
      @if (smartphoto$ | async; as smartphoto) {
        @if (smartphoto.waitingForAI) {
          <div class="smartphoto-detail__overlay">
            <div class="smartphoto-detail__loading-container">
              <lottie-player src="../../../assets/animations/loading-tire.json" background="transparent" speed="1" loop autoplay>
              </lottie-player>
              <p>
                {{ 'loading_explanation' | i18nextEager }}
                <br />
                {{ 'loading_time_explanation' | i18nextEager }}
              </p>
            </div>
          </div>
        }
      }
      <div class="smartphoto-detail__buttons">
        <div
          class="smartphoto-detail__button"
          (click)="select('info')"
          [ngClass]="{
            'smartphoto-detail__button--selected': selected === 'info',
            'smartphoto-detail__button--disabled': selected !== 'info' && !transactionService.empty
          }"
          data-test-id="smartphoto-detail-info"
        >
          <bdeo-icon
            [color]="selected === 'info' ? 'var(--cyantology)' : transactionService.empty ? 'var(--pigeon-grey)' : 'var(--cloudy-day)'"
            size="medium"
            name="file-cases"
          ></bdeo-icon>
        </div>

        @if (smartphotoService.abilities.showEstimation$ | async) {
          <div
            class="smartphoto-detail__button"
            (click)="select('estimation')"
            [ngClass]="{
              'smartphoto-detail__button--selected': selected === 'estimation',
              'smartphoto-detail__button--disabled': selected !== 'estimation' && !transactionService.empty
            }"
            data-test-id="smartphoto-detail-estimation"
          >
            <bdeo-icon
              [color]="
                selected === 'estimation' ? 'var(--cyantology)' : transactionService.empty ? 'var(--pigeon-grey)' : 'var(--cloudy-day)'
              "
              size="medium"
              name="money"
            ></bdeo-icon>
          </div>
        }

        <div
          class="smartphoto-detail__button"
          (click)="select('pictures')"
          [ngClass]="{
            'smartphoto-detail__button--selected': selected === 'pictures',
            'smartphoto-detail__button--disabled': selected !== 'pictures' && !transactionService.empty
          }"
          data-test-id="smartphoto-detail-pictures"
        >
          <bdeo-icon
            [color]="selected === 'pictures' ? 'var(--cyantology)' : transactionService.empty ? 'var(--pigeon-grey)' : 'var(--cloudy-day)'"
            size="medium"
            name="media-image"
          ></bdeo-icon>
        </div>
      </div>

      @if (selected === 'info') {
        <app-smartphoto-info [smartphoto]="smartphoto"></app-smartphoto-info>
      } @else if (selected === 'estimation') {
        <app-smartphoto-damage-estimation-list
          [customPartsSelector]="company.smartphoto.partsStaticSelector"
        ></app-smartphoto-damage-estimation-list>
      } @else if (selected === 'pictures') {
        <app-smartphoto-pictures></app-smartphoto-pictures>
      }
    </div>
    <app-smartphoto-footer #footer [smartphoto]="smartphoto" [company]="company"></app-smartphoto-footer>
  }
}
